import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { useAdminAuth } from "@/features/admin/hooks/useAdminAuth";
import { LeagueDraftsDashboard } from "@/features/admin/leagues/components/LeagueDraftsDashboard";
import { AdminPageHeader } from "@/features/admin/shell/AdminPageHeader";
import { AdminShell } from "@/features/admin/shell/AdminShell";
import { useT } from "@/shared/i18n";
import { Skeleton } from "@/shared/ui/Skeleton";

export const Route = createFileRoute("/_adminGuarded/admin/leagues/")({
  component: AdminLeaguesPage,
});

function AdminLeaguesPage() {
  const t = useT();
  const { state } = useAdminAuth();
  const token = state.status === "authenticated" ? state.token : null;
  const rows = useQuery(api.admin.listLeagueDraftsAdmin, token ? { token } : "skip");

  return (
    <AdminShell breadcrumbs={[{ label: t("admin.leagues.title") }]}>
      <AdminPageHeader
        title={t("admin.leagues.title")}
        subtitle={t("admin.leagues.subtitle")}
      />

      {rows === undefined ? (
        <div className="flex flex-col gap-3">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-80 w-full" />
          <Skeleton className="h-80 w-full" />
        </div>
      ) : (
        <LeagueDraftsDashboard rows={rows} />
      )}
    </AdminShell>
  );
}
